import { DocumentType } from "@biblioteksentralen/cordata";
import { Box, BoxProps, HStack, Tag } from "@biblioteksentralen/react";
import { ResolvedPaletteColor } from "@libry-content/common";
import { getDocumentTypeLabel, getTranslatedDocumentTypeLabel } from "@libry-content/integrations";
import { ReactNode } from "react";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { useSitePalette } from "../../utils/useSitePalette";

type DocumentTypesProps = {
  documentTypes?: DocumentType[];
  documentTypeLabels?: string[];
} & BoxProps;

export const DocumentTypes = ({ documentTypes, documentTypeLabels, ...boxProps }: DocumentTypesProps) => {
  const palette = useSitePalette();
  const documentTypeLabelsToUse = documentTypes
    ? documentTypes.map((documentType) => getDocumentTypeLabel(documentType))
    : documentTypeLabels;
  const { lang } = useTranslation();

  if (!documentTypeLabelsToUse || documentTypeLabelsToUse.length == 0) return null;

  return (
    <Box {...boxProps}>
      <HStack as="ul" maxWidth="12rem" flexWrap="wrap" gap="0.25rem">
        {documentTypeLabelsToUse.map((label) => (
          <TypeTag as="li" key={label} aria-label={label} styleColors={palette.colors.lightaccent3}>
            {getTranslatedDocumentTypeLabel(label, lang)}
          </TypeTag>
        ))}
      </HStack>
    </Box>
  );
};

export const TypeTag = ({
  children,
  styleColors,
  ...tagProps
}: { children: ReactNode; styleColors?: ResolvedPaletteColor } & Tag.RootProps) => {
  return (
    <Tag.Root
      width="fit-content"
      whiteSpace="nowrap"
      textTransform="uppercase"
      fontSize="2xs" // TODO: Is this too small?
      fontWeight="semibold"
      minHeight="unset"
      padding=".15rem .2rem .1rem"
      borderRadius="xs"
      minWidth="0"
      border="none"
      variant="solid"
      {...styleColors?.css}
      {...tagProps}
    >
      {children}
    </Tag.Root>
  );
};
